import { Link } from "@tanstack/react-router";
import type { ComponentProps, ReactNode } from "react";

import { cn } from "@/lib/utils";

type Props = ComponentProps<typeof Link> & { children: ReactNode };

export function OutlineButton({ className, ...props }: Props) {
  return <Link {...props} className={cn("t-button treatment-outline-button", className)} />;
}